import type { PickedVariant } from "@/modules/orders/presentation/ui/ProductPickerModal";
import type { RestockWaitlistLineDTO } from "../../domain/types";
import type { WaitlistFormLine } from "../ui/WaitlistLinesEditor";

export function waitlistLineDtoToFormLine(
  line: RestockWaitlistLineDTO,
): WaitlistFormLine {
  const variant: PickedVariant = {
    variantId: line.variantId,
    productName: line.productName,
    variantName: line.variantName,
    unitPrice: line.variantUnitPrice,
    imageKey: null,
    stockQuantity: line.stockOnHand,
    stockUnitLabel: "ຊິ້ນ",
    receiveUnitLabel: null,
    receiveConversionFactor: "1",
    unitsPerSale: line.variantUnitsPerSale,
  };

  return {
    lineKey: line.id,
    variant,
    quantity: line.quantityRequested,
  };
}
